export class EventBus {
  constructor(appId) {
    this._appId = appId;
    this._h = new Map();
  }

  on(ev, fn) {
    if (!this._h.has(ev)) this._h.set(ev, []);
    this._h.get(ev).push(fn);
    return () => this.off(ev, fn);
  }

  off(ev, fn) {
    this._h.set(ev, (this._h.get(ev) || []).filter(f => f !== fn));
  }

  once(ev, fn) {
    const w = d => { fn(d); this.off(ev, w); };
    this.on(ev, w);
  }

  emit(ev, data = {}) {
    (this._h.get(ev) || []).forEach(fn => { try { fn(data); } catch (e) { console.error('[MC]', e); } });
    window.dispatchEvent(new CustomEvent(`mc:${ev}`, { bubbles: false, detail: { appId: this._appId, ...data } }));
  }
}
